import { useMemo } from 'react';
import { getHarvestsByHtx } from '../../../../store';
import { useStore } from '../../../../hooks/useStore';
import { useAuth } from '../../../../hooks/useAuth';
import { formatNumber } from '../../../../utils/format';

export default function HarvestStats() {
  useStore();
  const { user } = useAuth();
  const harvests = getHarvestsByHtx(user?.htxId);

  const stats = useMemo(() => {
    const total = harvests.length;
    const duKien = harvests.filter((h) => h.status === 'Dự kiến').length;
    const nongHoCapNhat = harvests.filter((h) => h.status === 'Nông hộ đã cập nhật').length;
    const choXacNhan = harvests.filter((h) => h.status === 'Chờ HTX xác nhận' || h.status === 'Nông hộ đã cập nhật').length;
    const htxDaXN = harvests.filter((h) => h.status === 'HTX đã xác nhận').length;
    const sanLuongThap = harvests.filter((h) => h.status === 'Sản lượng thấp').length;
    const hoanThanh = harvests.filter((h) => h.status === 'Hoàn thành').length;
    const huy = harvests.filter((h) => h.status === 'Hủy').length;
    const tre = harvests.filter((h) => {
      if (!h.ngayDuKien || h.status === 'Hoàn thành' || h.status === 'Hủy' || h.status === 'HTX đã xác nhận') return false;
      return new Date(h.ngayDuKien) < new Date();
    }).length;

    const totalDuKien = harvests.reduce((sum, h) => sum + h.soLuong, 0);
    const totalXN = harvests.reduce((sum, h) => sum + (h.actualYieldConfirmed || h.actualYield || h.soLuong), 0);

    return {
      total, duKien, nongHoCapNhat, choXacNhan, htxDaXN, sanLuongThap, hoanThanh, huy, tre,
      totalDuKien, totalXN,
    };
  }, [harvests]);

  const cards = [
    { label: 'Tổng lần thu hoạch', value: stats.total, color: 'text-slate-900' },
    { label: 'Chờ HTX xác nhận', value: stats.choXacNhan, color: 'text-sky-700' },
    { label: 'HTX đã xác nhận', value: stats.htxDaXN, color: 'text-agrida-700' },
    { label: 'Hoàn thành', value: stats.hoanThanh, color: 'text-agrida-700' },
    { label: 'Sản lượng thấp', value: stats.sanLuongThap, color: 'text-red-600' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-2">
      {cards.map((c) => (
        <div key={c.label} className="bg-white rounded-2xl border border-slate-200 px-3 py-3 text-center">
          <p className={`text-xl font-bold ${c.color}`}>{c.value}</p>
          <p className="text-[11px] text-slate-500 mt-0.5">{c.label}</p>
        </div>
      ))}
      <div className="bg-white rounded-2xl border border-slate-200 px-3 py-3 text-center">
        <p className="text-xl font-bold text-slate-900">{formatNumber(stats.totalDuKien)}</p>
        <p className="text-[11px] text-slate-500 mt-0.5">Dự kiến (kg)</p>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 px-3 py-3 text-center">
        <p className="text-xl font-bold text-slate-900">{formatNumber(stats.totalXN)}</p>
        <p className="text-[11px] text-slate-500 mt-0.5">Xác nhận (kg)</p>
      </div>
    </div>
  );
}